<template>
  <div class="ftr-description">
    <FooterText class="ftr-description__txt-section" v-if="screenWidth < 1150"/>
    <LogotypeCapital class="ftr-description__logo" />
    <p class="ftr-description__txt ftr-description__txt--thin">
      Кэпитал — это закрытый источник независимой аналитики и инвестиций в криптоиндустрии, одного из крупнейших русскоязычных криптосообществ — Крипто Нарния.
    </p>
    <p class="ftr-description__txt ftr-description__txt--heart">
      Сделано с <span class="ftr-description__heart">&#x2764;</span> для децентрализованного мира.
    </p>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useScreenSize } from "@shared/composables/screenWidth/useScreenSize";
  //------------------------------------
  import LogotypeCapital from '@shared/UI/Logotypes/LogotypeCapital/LogotypeCapital.vue';
  import FooterText from '../FooterText/FooterText.vue';
  //------------------------------------
  const { screenWidth } = useScreenSize();
  //Получаем текущий год
  const get_currentYear = computed(()=> new Date().getFullYear());
</script>

<style scoped lang="scss">
  @import './styles';
</style>